import { render } from "./ProductList.vue?vue&type=template&id=3794849e&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"

import "./ProductList.vue?vue&type=style&index=0&id=3794849e&scoped=true&lang=css"
import "./ProductList.vue?vue&type=style&index=1&id=3794849e&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3794849e"]])

export default __exports__